import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsObjectRoute: InvariantJiraRoute = {
	name: 'assets-object',
	path: '/jira/assets/object/:objectId',
};
